import { EntityAboutCard, EntityLayout } from '@backstage/plugin-catalog';
import { EntityLayoutWrapper } from './common/EntityLayoutWrapper';
import { Grid } from '@backstage/ui';
import { EntityWarningContent } from './common/EntityWarningContent';

export const defaultEntity = (
  <EntityLayoutWrapper>
    <EntityLayout.Route path="/" title="Overview">
      <Grid.Root columns="12" gap="4">
        {EntityWarningContent}
        <Grid.Item colSpan={{ initial: '12', md: '6' }}>
          <EntityAboutCard />
        </Grid.Item>
      </Grid.Root>
    </EntityLayout.Route>
  </EntityLayoutWrapper>
);
